<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/faqs',
          title: 'FAQs'
        }
      ]"
      :value="faqsPage.hero_section"
    >
      <template v-if="faqsPage.hero_section.cta" #cta>
        <HeroCta :value="faqsPage.hero_section.cta" />
      </template>
    </HeroSection>

    <FaqsSection
      :faq-categories="faqCategories"
      :value="{}"
      class="mb-16 hero-section hero-below-offset"
    />

    <ContactCtaSection :value="faqsPage.contact_cta_section" class="mb-16" />
  </div>
</template>

<script setup>
defineProps({
  faqCategories: {
    required: true,
    type: Array
  },
  faqsPage: {
    required: true,
    type: Object
  }
})
</script>
